const parseVersion = (version: string): number[] =>
    version.split('.').map((num) => parseInt(num, 10));

export const compareVersions = (v1: string, v2: string): number => {
    const parsedV1 = parseVersion(v1),
        parsedV2 = parseVersion(v2),
        maxLength = Math.max(parsedV1.length, parsedV2.length);

    for (let i = 0; i < maxLength; ++i) {
        const v1Digit = parsedV1[i] ?? 0;
        const v2Digit = parsedV2[i] ?? 0;

        if (v1Digit > v2Digit) return 1;
        if (v1Digit < v2Digit) return -1;
    }

    return 0;
};
